module.exports = __webpack_public_path__ + "static/media/mode-57.47b3fbc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-57.svg
// module id = 1011
// module chunks = 2